import { useApi } from "../../../swr/useApi";
import { productConditionsService } from "../../api_client";
import type { ProductConditionDto } from "../../../api";

export function useProductConditions() {
    return useApi<ProductConditionDto[]>("product-conditions", async () => {
        return await productConditionsService.getProductConditions();
    });
}


